import { render, staticRenderFns } from "./JCElderDetail.vue?vue&type=template&id=18af6b90&scoped=true&"
import script from "./JCElderDetail.vue?vue&type=script&lang=js&"
export * from "./JCElderDetail.vue?vue&type=script&lang=js&"
import style0 from "./JCElderDetail.vue?vue&type=style&index=0&id=18af6b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af6b90",
  null
  
)

export default component.exports